import React from 'react';
import { Box } from '@goodrx/matisse-react';
import { ComponentRenderer, DataAttributionContext } from '@goodrx/x-core';
import { PageMeta } from '../PageMeta';
export const PageContainer = ({
  className,
  componentMap,
  contentCollection,
  heroCollection,
  pageMeta
}) => {
  const {
    items: contentItems
  } = contentCollection || {
    items: []
  };
  const {
    items: heroItems
  } = heroCollection || {
    items: []
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, pageMeta && /*#__PURE__*/React.createElement(PageMeta, pageMeta), /*#__PURE__*/React.createElement(Box, {
    className: className
  }, heroItems.map((data, i) => /*#__PURE__*/React.createElement(DataAttributionContext.Provider, {
    value: {
      location: 'Hero',
      contentCategory: data.displayTitle,
      contentCategoryId: data.sys.id,
      contentPosition: i + 1
    },
    key: data.sys.id
  }, /*#__PURE__*/React.createElement(ComponentRenderer, {
    data: data,
    componentMap: componentMap
  })))), /*#__PURE__*/React.createElement(Box, {
    className: className
  }, contentItems.map((data, i) => /*#__PURE__*/React.createElement(DataAttributionContext.Provider, {
    value: {
      location: 'Content',
      contentCategory: data.displayTitle,
      contentCategoryId: data.sys.id,
      contentPosition: i + 1
    },
    key: data.sys.id
  }, /*#__PURE__*/React.createElement(ComponentRenderer, {
    data: data,
    componentMap: componentMap,
    key: data.sys.id
  })))));
};